@if (content() === undefined) {
    <div class="flex min-h-64 flex-col items-center justify-center">
        <app-loader color="#EE5769"></app-loader>
    </div>
} @else if (content()) {
    <builder-content
        [model]="model()"
        [content]="content()"
        [apiKey]="builderIOAPIKey"
        [customComponents]="customComponents"></builder-content>
} @else {
    <app-not-found></app-not-found>
}
